// src/utils/pmoLabels.js

export const PMO_SCOPE_LABELS = {
    portfolio: "Portafolio PMO",
    project: "Proyecto completo",
};

export const PMO_METRIC_LABELS = {
    officialProgress: "Avance oficial",
    operationalProgress: "Avance operativo",
    averageProgress: "Avance operativo",
};

export const PMO_WBS_LABELS = {
    parentTask: "Paquete WBS",
    childTask: "Tarea WBS",
};

export const PMO_ROUTE_LABELS = {
    blocked: "Ruta bloqueada",
    released: "Ruta liberada",
};

export const PMO_EVIDENCE_LABELS = {
    complete: "Evidencia completa",
    missingGeo: "Falta geoevidencia",
    missingEvidence: "Falta evidencia",
    pending: "Evidencia pendiente",
};

export function getScopeLabel(projectId) {
    return projectId && String(projectId) !== "all"
        ? PMO_SCOPE_LABELS.project
        : PMO_SCOPE_LABELS.portfolio;
}

export function getReviewStatusLabel(task = {}) {
    const status = String(task.status || "").toLowerCase();
    const reviewStatus = String(task.review_status || "").toLowerCase();

    if (reviewStatus === "aprobado" && status === "en_proceso") {
        return "Aprobado parcial";
    }

    if (reviewStatus === "aprobado" && status === "terminada") {
        return "Aprobado";
    }

    if (reviewStatus === "en_revision") {
        return "En revision";
    }

    if (reviewStatus === "pendiente_revision") {
        return "Pendiente de revision";
    }

    if (reviewStatus === "rechazado") {
        return "Requiere ajustes";
    }

    if (reviewStatus === "borrador") {
        return "Sin revision activa";
    }

    return "Sin revision activa";
}

export function getTaskStatusLabel(status) {
    const value = String(status || "").toLowerCase();

    const labels = {
        pendiente: "Pendiente",
        en_proceso: "En proceso",
        bloqueada: "Bloqueada",
        terminada: "Terminada",
        cancelada: "Cancelada",
    };

    return labels[value] || "Sin estado";
}

export function getTaskTypeLabel(task = {}) {
    const hasChildren =
        Number(task.children_count || 0) > 0 ||
        Number(task.is_parent || 0) === 1 ||
        String(task.task_type || "").toLowerCase() === "parent" ||
        String(task.task_type || "").toLowerCase() === "phase";

    return hasChildren ? PMO_WBS_LABELS.parentTask : PMO_WBS_LABELS.childTask;
}

export function getRouteStatusLabel(task = {}) {
    const isBlocked =
        String(task.status || "").toLowerCase() === "bloqueada" ||
        Number(task.is_blocked || 0) === 1 ||
        String(task.route_status || "").toLowerCase() === "blocked";

    return isBlocked ? PMO_ROUTE_LABELS.blocked : PMO_ROUTE_LABELS.released;
}

export function getEvidenceStatusLabel(item = {}) {
    const hasEvidence =
        Number(item.evidence_count || 0) > 0 ||
        Number(item.geo_evidences || 0) > 0 ||
        Number(item.total_geo_evidences || 0) > 0 ||
        Number(item.has_evidence || 0) === 1 ||
        Boolean(item.evidence_url) ||
        Boolean(item.file_name) ||
        Boolean(item.file_url) ||
        Boolean(item.title) ||
        Boolean(item.evidence_title);

    const hasGeo =
        Number(item.geo_evidence_count || 0) > 0 ||
        Number(item.has_geo || 0) === 1 ||
        Number(item.has_geoevidence || 0) === 1 ||
        Boolean(item.latitude && item.longitude) ||
        Boolean(item.geo_lat && item.geo_lng);

    if (hasEvidence && hasGeo) {
        return PMO_EVIDENCE_LABELS.complete;
    }

    if (hasEvidence && !hasGeo) {
        return PMO_EVIDENCE_LABELS.missingGeo;
    }

    return PMO_EVIDENCE_LABELS.missingEvidence;
}

export function getDependencyLabel(task = {}) {
    const dependencyType = String(task.dependency_type || "").toUpperCase();

    if (!task.depends_on_task_id) {
        return "Sin dependencia";
    }

    if (dependencyType === "FS") {
        return "Finaliza para iniciar";
    }

    if (dependencyType === "SS") {
        return "Inicia con inicio";
    }

    return "Dependencia configurada";
}

export function getPriorityLabel(priority) {
    const value = String(priority || "").toLowerCase();

    const labels = {
        baja: "Baja",
        media: "Media",
        alta: "Alta",
        critica: "Critica",
    };

    return labels[value] || "Sin prioridad";
}

export function getProjectHealthLabel(healthStatus) {
    const value = String(healthStatus || "").toLowerCase();

    const labels = {
        verde: "En control",
        amarillo: "Requiere atencion",
        rojo: "Critico",
    };

    return labels[value] || "Sin lectura";
}